export const environment = {
  envName: 'dev',
  production: false,
  companyRedirectUrl: 'https://mobeus-dev.com',
  browserLinkUrl: 'https://delicious.services'
};
